import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-avisoslin',
  templateUrl: 'avisoslin.html',
})
export class AvisoslinPage {

  muestragif = "";
  imagenobtenida;
  imagenes;
  imaahora;
  grupoid;
  tabla;
  caption: string;

  myForm: FormGroup;
  rsx;
  v;


  constructor(
  	public navCtrl: NavController,
  	public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public params: NavParams,
    public viewCtrl: ViewController,
    public variables:VariablesProvider

    ) {

    this.caption = params.get('caption');
    this.grupoid = params.get('valor');
    this.tabla = params.get('tabla');
    this.rsx = params.get('rsx');
    this.v = params.get('id');
    
    this.caption = params.get('caption');
    this.grupoid = params.get('idgrupo');
    this.tabla = params.get('tabla');

   	

    this.myForm = this.fb.group({
      aviso1: [this.rsx[this.v].AVISO1, [Validators.required]],
      texto1: [this.rsx[this.v].TEXTO1, [Validators.required]],
      aviso2: [this.rsx[this.v].AVISO2, [Validators.required]],
      texto2: [this.rsx[this.v].TEXTO2, [Validators.required]],
      aviso3: [this.rsx[this.v].AVISO3, [Validators.required]],
      texto3: [this.rsx[this.v].TEXTO3, [Validators.required]],
      aviso4: [this.rsx[this.v].AVISO4, [Validators.required]],
      texto4: [this.rsx[this.v].TEXTO4, [Validators.required]],
    });

  }

  ionViewDidLoad() {


  }


 dismiss() {
      


      if (this.myForm.value.aviso1=="") {
        this.myForm.value.aviso1 = "Null";
      }
      if (this.myForm.value.aviso2=="") {
        this.myForm.value.aviso2 = "Null"
      }
      if (this.myForm.value.aviso3=="") {
        this.myForm.value.aviso3 = "Null"
      }

      if (this.myForm.value.aviso4=="") {
        this.myForm.value.aviso4 = "Null"
      }

      if (this.myForm.value.texto1=="") {
        this.myForm.value.texto1 = "Null"
      }
      if (this.myForm.value.texto2=="") {
        this.myForm.value.texto2 = "Null"
      }
      if (this.myForm.value.texto3=="") {
        this.myForm.value.texto3 = "Null"
      }
      if (this.myForm.value.texto4=="") {
        this.myForm.value.texto4 = "Null"
      }

      this.variables.editarturnosaviso(
      this.rsx[this.v].ID,
      this.myForm.value.aviso1,
      this.myForm.value.texto1,
      this.myForm.value.aviso2,
      this.myForm.value.texto2,
      this.myForm.value.aviso3,
      this.myForm.value.texto3,
      this.myForm.value.aviso4,
      this.myForm.value.texto4
      ).then(
          data => {  }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
      this.viewCtrl.dismiss(
      {
        'trabajadores': "this.puestos",
        'turnos': "this.turnos"
      }
    ); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/avisoslin/avisoslin.ts